import { ApiService } from "pwapi";

import { createRequestConstants } from "shared/actions/constants";
import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

export const SHIPMENTS = {
  LIST: createRequestConstants("@@manage/LIST_SHIPMENTS"),
  GET: createRequestConstants("@@manage/GET_SHIPMENT"),
  PRINT: createRequestConstants("@@manage/PRINT_SHIPMENT"),
};

export const listShipments = createAsyncSaga(
  SHIPMENTS.LIST.REQUEST,
  SHIPMENTS.LIST.SUCCESS,
  SHIPMENTS.LIST.ERROR,
  ({ parentLookupLabStationId, limit, offset }) =>
    `lis/${parentLookupLabStationId}/shipments/${limit}/${offset}/`,
  ({ parentLookupLabStationId, limit, offset }) =>
    ApiService.listShipments({ parentLookupLabStationId, limit, offset })
) as AsyncSagaAction<Parameters<typeof ApiService.listShipments>[0]>;

export const getShipment = createAsyncSaga(
  SHIPMENTS.GET.REQUEST,
  SHIPMENTS.GET.SUCCESS,
  SHIPMENTS.GET.ERROR,
  ({ parentLookupLabStationId, id }) =>
    `shipments/get/${parentLookupLabStationId}/${id}`,
  ({ parentLookupLabStationId, id }) =>
    ApiService.retrieveShipment({ parentLookupLabStationId, id })
) as AsyncSagaAction<Parameters<typeof ApiService.retrieveShipment>[0]>;

export const printShipment = createAsyncSaga(
  SHIPMENTS.PRINT.REQUEST,
  SHIPMENTS.PRINT.SUCCESS,
  SHIPMENTS.PRINT.ERROR,
  ({ parentLookupLabStationId }) =>
    `shipments/print/${parentLookupLabStationId}`,
  ({ parentLookupLabStationId }) =>
    ApiService.printShipment({ parentLookupLabStationId })
) as AsyncSagaAction<Parameters<typeof ApiService.printShipment>[0]>;
